import React from 'react';
import { Markdown, PageBanner } from '../shared/layout/components';
import { Container, Box, Grid, Paper, Typography } from '@mui/material';
import { LoadingIndicator, Meta } from '../shared';
import { useConsult } from '../api/contact/consultationQuery';
import { ContactEmployeeBlock, DynamicsFormComponent } from './components';

export const FreeConsultationPage: React.FC = () => {
  const consultQuery = useConsult();
  if (!consultQuery.data) return <LoadingIndicator />;
  return (
    <Box>
      <Meta seo={consultQuery.data.consultationPage.data.attributes.SEO} />
      <PageBanner
        headline={consultQuery.data.consultationPage.data.attributes.Banner.Headline}
        subCopy={consultQuery.data.consultationPage.data.attributes.Banner.Subhead}
      />
      <Container maxWidth="xl">
        <Grid container spacing={4}>
          <Grid
            item
            xs={12}
            lg={8}
            sx={{ '& iframe': { border: 0, minHeight: '500px' } }}
            flexDirection="column"
          >
            <Markdown children={consultQuery.data.consultationPage.data.attributes.PageCopy} />
          </Grid>
          <Grid item xs={12} lg={4}>
            <Paper variant="roundedGrey">
              <Typography variant="h4">Free Consultation</Typography>
              <DynamicsFormComponent
                form={
                  consultQuery.data.consultationPage.data.attributes.DynamicsForm.data.attributes
                }
              />
              <ContactEmployeeBlock
                contactEmployee={
                  consultQuery.data.consultationPage.data.attributes.MeetingEmployee.data.attributes
                }
              />
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};
